import React from 'react';
import { Helmet } from 'react-helmet-async';
import { News } from '../types';

interface StructuredDataProps {
  news?: News[];
  type?: 'NewsArticle' | 'WebSite';
}

const StructuredData: React.FC<StructuredDataProps> = ({ news, type = 'WebSite' }) => {
  const getStructuredData = () => {
    if (type === 'NewsArticle' && news && news.length > 0) {
      return news.map((article) => ({
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        headline: article.title,
        description: article.content,
        datePublished: article.created_at,
        dateModified: article.created_at,
        author: {
          '@type': 'Organization',
          name: article.team_name || 'Transfer News'
        },
        publisher: {
          '@type': 'Organization',
          name: 'Transfer News',
          logo: {
            '@type': 'ImageObject',
            url: '/logo.png'
          }
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': article.url
        }
      }));
    }

    return {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Transfer News',
      url: window.location.origin,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${window.location.origin}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string'
      }
    };
  };

  const structuredData = getStructuredData();

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData; 